import { render, staticRenderFns } from "./CariTanimla.vue?vue&type=template&id=f72bd720&"
import script from "./CariTanimla.vue?vue&type=script&lang=js&"
export * from "./CariTanimla.vue?vue&type=script&lang=js&"
import style0 from "./CariTanimla.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports